module.exports = __webpack_public_path__ + "static/media/trip-plannerr.9a9ab2b7.png";